import React from 'react';
import {
  IReportsGroupTotalItem,
  IReportsTableColumnHeading,
} from 'features/timeAndActivityReports/timeAndActivityReportsTypes';
import { numToCurrencyWithLocale } from 'helpers/numToCurrencyWithLocale';
import { organizationInfoSelector } from 'features/organization/organizationSlice';
import { useSelector } from 'react-redux';

interface TotalRowItemProps {
  item: IReportsGroupTotalItem;
  column: IReportsTableColumnHeading;
}

export const TotalRowItem: React.FC<TotalRowItemProps> = ({ item, column }) => {
  const organizationInfo = useSelector(organizationInfoSelector)

  return (
    <>
      <td key={column.value}>
        {column.value === 'billedAmount'
          ? numToCurrencyWithLocale(item[column.value], organizationInfo.currency.code, 'en-US')
          : column.value === 'time' ||
            column.value === 'billableTime' ||
            column.value === 'nonBillableTime'
          ? item[column.value]
          : ''}
      </td>
    </>
  );
};

export default TotalRowItem;
